/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverShiftsListViewNavigation: "driver-shifts-list-view-navigation",
  driverShiftsListTableView: "driver-shifts-list-table-view",
  driverShiftsListCalendarView: "driver-shifts-list-calendar-view",
  driverShiftsListCreateShift: "driver-shifts-list-create-shift",
} as const;
